import React, { useState, useEffect } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
// import io from 'socket.io-client';
// import Timer from 'react-timer-wrapper';
// import moment from 'moment';
// import { isMobile } from 'react-device-detect';
// import { loadTossPayments } from '@tosspayments/payment-sdk';
import QRCode from 'react-qr-code';
import Barcode from 'react-barcode';
import '../css/yemae.css';

// const socket = io('http://son.aniplustv.com:4000');

const SeatReserveDetail = (props) => {
  const { apiUrl, loginId, pkg, nicName, icon, socket } = props;
  const {
    orderCode,
    showSeat,
    ticketCode,
    charImg,
    cnt,
    param,
    popupClose,
    gPage,
  } = props.childProps;
  const [gotoPage, setGotoPage] = useState(1);
  const [barcode, setBarcode] = useState('');
  const [listDetail, setListDetail] = useState([]);
  const pageSize = 4;

  const _getData = async (orderCode) => {
    const result = await axios.post(`${apiUrl}/seatReserveMyListDetail`, {
      orderCode: orderCode,
      userid: loginId,
      pkg,
      gotoPage: gotoPage,
      pageSize,
    });

    const intReturn = result.data[0].intReturn;
    const con = result.data[0].con;
    const pageCount = result.data[0].pageCount;
    const barcode = result.data[0].barcode;

    console.log(intReturn);
    if (intReturn === 0) {
      console.log('상세페이지');
      //   setOrderCode(orderCode);
      setBarcode(barcode);
      setListDetail(result.data[0].listData);
    }
  };
  const getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };
  useEffect(() => {
    _getData(orderCode);
  }, [orderCode]);

  console.log(orderCode);
  console.log(listDetail);

  return (
    <div className="gumaenaeyeog_page">
      <div className="float_left">
        <div className="left_title_text">티켓구매내역</div>
        <div className="pop_user">
          <dl>
            <dt>
              <img src={getCookie('ic')} />
            </dt>
            <dd>
              {nicName}님
              <br />
              <span>(총 {cnt}건)</span>
            </dd>
          </dl>
        </div>
        <div className="bagkodeu_div">
          {listDetail.length > 0 ? (
            <QRCode
              style={{ width: '80%' }}
              value={`https://t.aniplustv.com:4000/u/${listDetail[0].qrcodeUrl}`}
            />
          ) : null}
        </div>

        <div class="left_bg3">
          <img src="/img/seat/pop_left_btn.jpg" useMap="#Map100" />
          <map name="Map100">
            <area
              shape="rect"
              coords="6,5,93,80"
              onClick={() => showSeat('')}
              style={{ cursor: 'pointer' }}
            />
            <area
              shape="rect"
              coords="103,4,189,80"
              href="javascript:window.print()"
            />
          </map>
        </div>
      </div>

      <div className="float_right">
        <div className="right_padding">
          <table
            width="100%"
            border="0"
            cellspacing="0"
            cellpadding="0"
            className="pop_list_table"
          >
            <colgroup>
              <col width="100px" />
              <col width="" />
              <col width="98px" />
              <col width="97px" />
              <col width="97px" />
            </colgroup>
            <thead>
              <tr>
                <th>일자</th>
                <th>회차(시간)</th>
                <th>상영관</th>
                <th>좌석번호</th>
                <th>금액</th>
              </tr>
            </thead>
            <tbody>
              {listDetail.length > 0 ? (
                listDetail.map((item) => (
                  <tr>
                    <td>
                      {item.rdate.substr(0, 4)}.{item.rdate.substr(4, 2)}.
                      {item.rdate.substr(6, 2)}
                    </td>
                    <td>
                      {item.rtime.substr(0, 2)}:{item.rtime.substr(2, 2)}
                    </td>
                    <td>{item.room}</td>
                    <td>{item.ticket}</td>
                    <td>{item.ticketPrice.toLocaleString('ko-KR')}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5">{/*예매 내역이 존재하지 않습니다.*/}</td>
                </tr>
              )}
            </tbody>
          </table>
          <div className="page_no"></div>
        </div>
        <hr width="80%" style={{ borderTop: '1px dashed #8c8b8b;' }} />
        <div className="barcode-box">
          <Barcode
            value={barcode}
            displayValue={false}
            height={70}
            format="CODE128"
            fontSize={9}
            margin={2}
            textMargin={1}
            width={2}
          />
        </div>
      </div>

      <div style={{ clear: 'both' }}></div>
      <div className="gumaenaeyeog_pop_back" onClick={() => showSeat('')}>
        &lt; 뒤로
      </div>
      <div className="gumaenaeyeog_pop_close" onClick={popupClose}>
        <span>닫기</span>
      </div>
    </div>
  );
};

export default shopContext(withRouter(SeatReserveDetail));
